module.exports = __webpack_public_path__ + "static/media/left-caret-white-circle.b3feadaa.svg";